<div class="modal-overlay">
    <div class="geniric-modal" [ngStyle]="{
        width: config?.width ? config?.width?.value + config?.width?.unit : 'fit-content',
        height: config?.height ? config?.height?.value + config?.height?.unit : (config?.fitContent ? 'fit-content' : '90vh'),
        'max-height': '96vh',
        'border-radius': config?.borderRadius ? config?.borderRadius?.value + config.borderRadius.unit : '8px'}">
        <div class="geniric-modal-header" [ngStyle]="{
            'background-color': config?.header_background_color ? config?.header_background_color : '#fafafa',
            'border-color': config?.header_border_color ? config?.header_border_color : '#dee2e6'}">
            <div class="title-hint-wrapper">
                <div class="title" [ngStyle]="{
                    'color': config?.header_title_color ? config?.header_title_color : '#1d71d3'}">
                    {{getModalTitle(config.mode) | translate}}
                </div>
                <div *ngIf="config?.showTitleHint" class="hint" [ngStyle]="{
                    'color': config?.titleHintColor ? config?.titleHintColor : '#101828'}">
                    {{config?.titleHint | translate}}
                </div>
            </div>
            <div class="geniric-header-btns d-flex">
                <button *ngIf="config?.header_deactivate?.visible &&
                config?.data?.schools[0]?.pivot.is_active" [class]="config?.header_deactivate?.class"
                    (click)="toggleActivation(config?.content)">
                    {{config?.header_deactivate?.label | translate}}
                </button>
                <button *ngIf="config?.header_activate?.visible &&
                !config?.data?.schools[0]?.pivot.is_active" [class]="config?.header_activate?.class"
                    (click)="toggleActivation(config?.content)">
                    {{config?.header_activate?.label | translate}}
                </button>
                <button *ngIf="config?.header_edit?.visible && config.mode == 'view'"
                    [class]="config?.header_edit?.class" (click)="config.mode = 'edit'">
                    {{config?.header_edit?.label | translate}}
                </button>
                <button *ngIf="config?.header_save?.visible && config.mode == 'edit'"
                    [class]="config?.header_save?.class" [disabled]="saveDisabled"
                    (click)="saveFromHeader(config?.content)">
                    {{config?.header_save?.label | translate}}
                </button>
                <!-- Add Parent walks two steps, so its header button changes with
                     the step. The state is pushed up by the child; the clicks go
                     straight back to it. -->
                <ng-container *ngIf="config?.content == 'create-parent'">
                    <button *ngIf="createParentHeader.step === 2" class="brBtn brBtn-transparent-blue"
                        [disabled]="createParentHeader.saving" (click)="addParentModalChild?.backToStudentStep()">
                        {{'add-parent-flow.back' | translate}}
                    </button>
                    <button *ngIf="createParentHeader.step === 1" class="brBtn brBtn-primary"
                        [disabled]="!createParentHeader.canContinue" (click)="addParentModalChild?.goToParentStep()">
                        {{'add-parent-flow.continue' | translate}}
                    </button>
                    <button *ngIf="createParentHeader.step === 2" class="brBtn brBtn-primary"
                        [disabled]="createParentHeader.saveBlocked" (click)="addParentModalChild?.saveParent()">
                        {{ (createParentHeader.saving ? 'add-parent-flow.saving' : 'add-parent-flow.save') | translate }}
                    </button>
                </ng-container>
                <button class="close">
                    <span (click)="close.emit()" aria-hidden="true">×</span>
                </button>
                <!-- <button (click)="testChilds()">Test</button> -->
            </div>
        </div>
        <div class="geniric-modal-body" [ngStyle]="{
            'overflow-y': config?.overflow ? config?.overflow?.overflowY : 'auto'}">
            <div *ngIf="config.content == 'student'">
                <app-student-modal #studentModalChild [config]="config" [lang]="lang"></app-student-modal>
            </div>
            <div *ngIf="config.content == 'parent'">
                <app-parent-modal #parentModalChild [config]="config" [lang]="lang"></app-parent-modal>
            </div>
            <div *ngIf="config.content == 'create-parent'">
                <app-add-parent-modal #addParentModalChild [config]="config" [lang]="lang"
                    (headerState)="onCreateParentHeaderState($event)"></app-add-parent-modal>
            </div>
            <div *ngIf="config.content == 'assistant'">
                <app-assistant-modal #assistantModalChild [config]="config" [lang]="lang"></app-assistant-modal>
            </div>
            <div *ngIf="config.content == 'assign-assistant'">
                <!-- <app-parent-modal #parentModalChild [config]="config" [lang]="lang"></app-parent-modal> -->

                <app-assign-assistant #assignAssistantModalChild [config]="config" [lang]="lang"></app-assign-assistant>
            </div>
            <div *ngIf="config.content == 'export-staff'">
                <app-export-staff-modal #exportStaffModalChild [config]="config" [lang]="lang"></app-export-staff-modal>
            </div>
        </div>

        <!-- <div *ngIf="config?.show_footer" class="geniric-modal-footer">
            <button class="btn" *ngFor="let action of config.actions" (click)="action.action()">
                {{ action.label }}
            </button>
            <button (click)="close.emit()">Close</button>
        </div> -->
    </div>
</div>